import * as XLSX from "xlsx";

/**
 * تصدير تقرير Excel عام لجميع تقارير النظام
 *
 * المكتبة:
 * npm install xlsx
 *
 * الاستخدام:
 *
 * exportExcelReport({
 *   title: "كشف حساب",
 *   fromDate: FDate,
 *   toDate: TDate,
 *
 *   info: [
 *     { label: "اسم الحساب", value: accountName },
 *     { label: "رقم الحساب", value: accountNo },
 *   ],
 *
 *   columns: [
 *     {
 *       title: "التاريخ",
 *       field: "date",
 *       type: "date",
 *       width: 15
 *     },
 *     {
 *       title: "البيان",
 *       field: "description",
 *       width: 40
 *     },
 *     {
 *       title: "مدين",
 *       field: "debit",
 *       type: "number",
 *       width: 18
 *     }
 *   ],
 *
 *   data: reportData,
 *
 *   totals: [
 *     { label: "إجمالي المدين", field: "debit" },
 *     { label: "إجمالي الدائن", field: "credit" }
 *   ],
 *
 *   fileName: "كشف_حساب",
 *   sheetName: "كشف الحساب"
 * });
 */

export const exportExcelReport = ({
  // =========================================================
  // معلومات التقرير
  // =========================================================

  title = "تقرير",

//   companyName = "",
  info = [],
  columns = [],
  data = [],

  // =========================================================
  // الإجماليات
  // =========================================================

  totals = [],

  // =========================================================
  // اسم الملف
  // =========================================================

  fileName = "Report",

  sheetName = "التقرير",

  // =========================================================
  // خيارات
  // =========================================================

  showSerial = false,

  showFilter = true,

  freezeHeader = true,

  rightToLeft = true,
}) => {

  try {

    // =======================================================
    // 1. التحقق
    // =======================================================

    if (!Array.isArray(columns) || columns.length === 0) {
      console.warn(
        "exportExcelReport: لا توجد أعمدة للتقرير"
      );

      return;
    }

    if (!Array.isArray(data)) {
      data = [];
    }

    // =======================================================
    // 2. إضافة الرقم التسلسلي إذا طلب
    // =======================================================

    let reportColumns = [...columns];

    if (showSerial) {

      reportColumns = [
        {
          title: "م",
          field: "__index",
          width: 8,
          type: "number"
        },

        ...reportColumns
      ];
    }

    // =======================================================
    // 3. مصفوفة Excel
    // =======================================================

    const rows = [];

    // =======================================================
    // 4. اسم الشركة
    // =======================================================

    // if (companyName) {
    //   rows.push([companyName]);
    // }

    // =======================================================
    // 5. عنوان التقرير
    // =======================================================

    rows.push([title]);

    // =======================================================
    // 6. معلومات الفترة
    // =======================================================

    // if (fromDate || toDate) {

    //   rows.push([
    //     fromDate
    //       ? `من تاريخ: ${fromDate}`
    //       : "",

    //     toDate
    //       ? `إلى تاريخ: ${toDate}`
    //       : ""
    //   ]);
    // }

    // =======================================================
    // 7. المعلومات الإضافية
    // =======================================================

    if (
      Array.isArray(info) &&
      info.length > 0
    ) {

      // كل صف يحتوي معلومتين
      for (
        let i = 0;
        i < info.length;
        i += 2
      ) {

        const first =
          info[i];

        const second =
          info[i + 1];

        rows.push([
          first
            ? first.label
            : "",

          first
            ? first.value
            : "",

          second
            ? second.label
            : "",

          second
            ? second.value
            : ""
        ]);
      }
    }

    // =======================================================
    // 8. سطر فارغ قبل الجدول
    // =======================================================

    rows.push([]);

    // =======================================================
    // 9. عناوين الجدول
    // =======================================================

    const headerRowIndex =
      rows.length;

    rows.push(
      reportColumns.map(
        column => column.title || ""
      )
    );

    // =======================================================
    // 10. بيانات الجدول
    // =======================================================

    data.forEach(
      (item, index) => {

        const row =
          reportColumns.map(
            column => {

              // ---------------------------------------------
              // الرقم التسلسلي
              // ---------------------------------------------

              if (
                column.field === "__index"
              ) {

                return index + 1;
              }

              // ---------------------------------------------
              // القيمة
              // ---------------------------------------------

              let value =
                item?.[
                  column.field
                ];

              // ---------------------------------------------
              // null / undefined
              // ---------------------------------------------

              if (
                value === null ||
                value === undefined
              ) {

                value = "";
              }

              // ---------------------------------------------
              // Formatter
              // ---------------------------------------------

              if (
                typeof column.formatter ===
                "function"
              ) {

                value =
                  column.formatter(
                    value,
                    item,
                    index
                  );
              }

              // ---------------------------------------------
              // الرقم
              // ---------------------------------------------

              if (
                column.type === "number"
              ) {

                if (
                  value !== "" &&
                  !isNaN(value)
                ) {

                  value =
                    Number(value);
                }
              }

              return value;
            }
          );

        rows.push(row);
      }
    );

    // =======================================================
    // 11. الإجماليات
    // =======================================================

    if (
      Array.isArray(totals) &&
      totals.length > 0
    ) {

      // سطر فارغ
      rows.push([]);

      totals.forEach(
        total => {

          const totalRow =
            new Array(
              reportColumns.length
            ).fill("");

          // اسم الإجمالي
          totalRow[0] =
            total.label ||
            "الإجمالي";

          // حساب الإجمالي
          if (total.field) {

            const totalValue =
              data.reduce(
                (
                  sum,
                  item
                ) => {

                  const value =
                    Number(
                      item?.[
                        total.field
                      ] ?? 0
                    );

                  if (
                    isNaN(value)
                  ) {

                    return sum;
                  }

                  return sum + value;

                },
                0
              );

            const columnIndex =
              reportColumns.findIndex(
                column =>
                  column.field ===
                  total.field
              );

            if (
              columnIndex >= 0
            ) {

              totalRow[
                columnIndex
              ] = totalValue;
            }
          }

          rows.push(
            totalRow
          );
        }
      );
    }

    // =======================================================
    // 12. إنشاء Worksheet
    // =======================================================

    const worksheet =
      XLSX.utils.aoa_to_sheet(
        rows
      );

    // =======================================================
    // 13. تحديد عدد الأعمدة
    // =======================================================

    const columnCount =
      reportColumns.length;

    // =======================================================
    // 14. دمج عنوان الشركة
    // =======================================================

    let currentRow = 0;

    // if (companyName) {

    //   worksheet["!merges"] =
    //     worksheet["!merges"] || [];

    //   worksheet["!merges"].push({
    //     s: {
    //       r: currentRow,
    //       c: 0
    //     },

    //     e: {
    //       r: currentRow,
    //       c: columnCount - 1
    //     }
    //   });

    //   currentRow++;
    // }

    // =======================================================
    // 15. دمج عنوان التقرير
    // =======================================================

    worksheet["!merges"] =
      worksheet["!merges"] || [];

    worksheet["!merges"].push({
      s: {
        r: currentRow,
        c: 0
      },

      e: {
        r: currentRow,
        c: columnCount - 1
      }
    });

    // =======================================================
    // 16. عرض الأعمدة
    // =======================================================

    worksheet["!cols"] =
      reportColumns.map(
        column => ({
          wch:
            column.width ||
            getColumnWidth(
              column,
              data
            )
        })
      );

    // =======================================================
    // 17. تنسيق الأرقام والتواريخ
    // =======================================================

    data.forEach(
      (item, dataIndex) => {

        reportColumns.forEach(
          (column, columnIndex) => {

            const excelRow =
              headerRowIndex +
              1 +
              dataIndex;

            const address =
              XLSX.utils.encode_cell({
                r: excelRow,
                c: columnIndex
              });

            const cell =
              worksheet[address];

            if (!cell) {
              return;
            }

            // رقم
            if (
              column.type === "number"
            ) {

              cell.z =
                column.numberFormat ||
                "#,##0.00";
            }

            // تاريخ
            if (
              column.type === "date"
            ) {

              cell.z =
                column.dateFormat ||
                "yyyy-mm-dd";
            }
          }
        );
      }
    );

    // =======================================================
    // 18. تنسيق الإجماليات
    // =======================================================

    if (
      totals.length > 0
    ) {

      const totalStartRow =
        headerRowIndex +
        1 +
        data.length +
        1;

      totals.forEach(
        (total, index) => {

          if (!total.field) {
            return;
          }

          const columnIndex =
            reportColumns.findIndex(
              column =>
                column.field ===
                total.field
            );

          if (
            columnIndex < 0
          ) {
            return;
          }

          const address =
            XLSX.utils.encode_cell({
              r:
                totalStartRow +
                index,

              c: columnIndex
            });

          const cell =
            worksheet[address];

          if (cell) {

            cell.z =
              total.numberFormat ||
              "#,##0.00";
          }
        }
      );
    }

    // =======================================================
    // 19. اتجاه الورقة RTL
    // =======================================================

    worksheet["!sheetViews"] = [
      {
        rightToLeft:
          rightToLeft
      }
    ];

    // =======================================================
    // 20. Filter
    // =======================================================

    if (
      showFilter &&
      data.length > 0
    ) {

      const lastDataRow =
        headerRowIndex +
        data.length;

      worksheet["!autofilter"] = {
        ref:
          `A${headerRowIndex + 1}:` +
          `${XLSX.utils.encode_col(
            columnCount - 1
          )}${lastDataRow + 1}`
      };
    }

    // =======================================================
    // 21. Freeze صف العناوين
    // =======================================================

    if (freezeHeader) {

      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit:
          headerRowIndex + 1
      };
    }

    // =======================================================
    // 22. إعدادات الطباعة
    // =======================================================

    worksheet["!pageSetup"] = {
      orientation: "landscape",
      paperSize: 9,
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 0
    };

    // =======================================================
    // 23. إنشاء Workbook
    // =======================================================

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      cleanSheetName(sheetName)
    );

    // =======================================================
    // 24. اسم الملف
    // =======================================================

    let finalFileName =
      fileName || "Report";

    finalFileName =
      finalFileName
        .replace(
          /[\\/:*?"<>|]/g,
          "-"
        )
        .trim();

    if (!finalFileName) {
      finalFileName =
        "Report";
    }

    // =======================================================
    // 25. التصدير
    // =======================================================

    XLSX.writeFile(
      workbook,
      `${finalFileName}.xlsx`
    );

  } catch (error) {

    console.error(
      "Excel Export Error:",
      error
    );

    throw error;
  }
};


// ===========================================================
// حساب عرض العمود
// ===========================================================

function getColumnWidth(
  column,
  data
) {

  let maxLength =
    String(
      column.title || ""
    ).length;

  const sample =
    data.slice(0, 500);

  sample.forEach(
    item => {

      let value =
        item?.[
          column.field
        ];

      if (
        value === null ||
        value === undefined
      ) {

        value = "";
      }

      if (
        typeof column.formatter ===
        "function"
      ) {

        value =
          column.formatter(
            value,
            item
          );
      }

      const length =
        String(value).length;

      if (
        length > maxLength
      ) {

        maxLength =
          length;
      }
    }
  );

  return Math.min(
    Math.max(
      maxLength + 3,
      12
    ),
    column.maxWidth || 50
  );
}


// ===========================================================
// تنظيف اسم Sheet
// Excel يسمح بحد أقصى 31 حرف
// ===========================================================

function cleanSheetName(
  name
) {

  return String(
    name || "التقرير"
  )
    .replace(
      /[\\\/\?\*\[\]:]/g,
      ""
    )
    .substring(0, 31);
}